import { render } from "./WizardLogin.vue?vue&type=template&id=5dcf7f34&scoped=true"
import script from "./WizardLogin.vue?vue&type=script&lang=js"
export * from "./WizardLogin.vue?vue&type=script&lang=js"

import "./WizardLogin.vue?vue&type=style&index=0&id=5dcf7f34&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcf7f34"]])

export default __exports__